<template>
  <div class="gallery-view container py-5">
    <!-- Header -->
    <div class="text-center mb-5">
      <h2 class="fw-bold text-gold">Temple Gallery</h2>
      <p class="text-muted">A glimpse into our sacred moments and spaces</p>
    </div>

    <!-- Gallery Grid -->
    <div class="row g-4 justify-content-center">
      <div
        v-for="(photo, index) in photos"
        :key="index"
        class="col-6 col-md-4 col-lg-3"
      >
        <div class="gallery-item shadow-sm rounded overflow-hidden">
          <img :src="photo" class="img-fluid gallery-img" alt="Temple photo" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import gallery1 from "@/assets/gallery/gallery1.jpg";
import gallery2 from "@/assets/gallery/gallery2.jpg";
import gallery3 from "@/assets/gallery/gallery3.jpg";
import gallery4 from "@/assets/gallery/gallery4.jpg";
import gallery5 from "@/assets/gallery/gallery5.jpg";
import gallery6 from "@/assets/gallery/gallery6.jpg";
import gallery7 from "@/assets/gallery/gallery7.jpg";
import gallery8 from "@/assets/gallery/gallery8.jpg";
import gallery9 from "@/assets/gallery/gallery9.jpg";
import gallery10 from "@/assets/gallery/gallery10.jpg";
import gallery11 from "@/assets/gallery/gallery11.jpg";
import gallery12 from "@/assets/gallery/gallery12.jpg";
import gallery13 from "@/assets/gallery/gallery13.jpg";
import gallery14 from "@/assets/gallery/gallery14.jpg";
import gallery15 from "@/assets/gallery/gallery15.jpg";
import gallery16 from "@/assets/gallery/gallery16.jpg";
import gallery17 from "@/assets/gallery/gallery17.jpg";
// import gallery8 from "@/assets/gallery/gallery8.jpg";

const photos = [
  gallery1,
  gallery2,
  gallery3,
  gallery4,
  gallery5,
  gallery6,
  gallery7,
  gallery8,
  gallery9,
  gallery10,
  gallery11,
  gallery12,
  gallery13,
  gallery14,
  gallery15,
  gallery16,
  gallery17,
  // gallery8,
];
</script>

<style scoped>
/* 🌸 Theme Color */
.text-gold {
  color: #c69f59;
}

/* 🖼️ Gallery Styling */
.gallery-item {
  border: 4px solid #f6e3b4;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.gallery-item:hover {
  transform: scale(1.03);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
}
.gallery-img {
  object-fit: cover;
  height: 220px;
  width: 100%;
  display: block;
}

/* 📱 Responsive Adjustments */
@media (max-width: 991px) {
  .gallery-view {
    padding: 2rem 1rem;
  }

  .gallery-img {
    height: 200px;
  }

  .gallery-item {
    border-width: 3px;
  }

  .gallery-view h2 {
    font-size: 1.9rem;
  }

  .gallery-view p {
    font-size: 1rem;
  }
}

@media (max-width: 576px) {
  .gallery-view {
    padding: 1.5rem 0.8rem;
  }

  .gallery-view h2 {
    font-size: 1.6rem;
  }

  .gallery-view p {
    font-size: 0.95rem;
  }

  .col-6 {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .gallery-item {
    border-width: 3px;
    margin-bottom: 1rem;
  }

  .gallery-img {
    height: 200px;
    border-radius: 10px;
  }
}

@media (max-width: 400px) {
  .gallery-view h2 {
    font-size: 1.4rem;
  }

  .gallery-img {
    height: 180px;
  }
}
</style>
